import React from "react";
import Navbar from "../components/Navbar";
import Banner from "../components/Banner";
import Courses from "../components/Courses";
import Books from "../components/Books";
import EnquiryForm from "../components/EnquiryForm";
import WhatsAppButton from "../components/WhatsAppButton";
import { Box } from "@mui/material";
import InterviewGuidance from "../components/InterviewGuidance";
import Footer from "../components/Footer";
import WhyChooseUs from "../components/WhyChooseUs";
import HowItWorks from "../components/HowItWorks";
import StudentsReviews from '../components/StudentsReviews'


const Home = () => {
  return (
    <Box>
      {/* <Navbar /> */}
      <Banner />
      <WhyChooseUs />
      <Courses />
      <StudentsReviews />

      {/* <HowItWorks /> */}
      {/* <Courses />
      <Books />
      <InterviewGuidance /> */}
      {/* <Footer /> */}
      {/* <EnquiryForm />
      <WhatsAppButton /> */}
    </Box>
  );
};

export default Home;
